/**
 * React Query hook for chatbot suggested starter prompts (CMS-driven).
 */
import { useQuery } from '@tanstack/react-query';
import {
  chatbotSuggestionsService,
  type SuggestionQuestion,
} from '@services/chatbot-suggestions.service';
import { useAuthStore } from '@store/auth.store';

export const chatbotSuggestionsKeys = {
  all: ['chatbotSuggestions'] as const,
  questions: () => [...chatbotSuggestionsKeys.all, 'questions'] as const,
};

export const useChatbotSuggestions = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery<SuggestionQuestion[]>({
    queryKey: chatbotSuggestionsKeys.questions(),
    queryFn: () => chatbotSuggestionsService.getSuggestedQuestions(),
    enabled: isAuthenticated,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 2,
  });
};

export default useChatbotSuggestions;
